/**
 * Formatters consistentes — sempre BR.
 */

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const intFormatter = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });

const dateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export function fmtBRL(value: number): string {
  return brlFormatter.format(value);
}

export function fmtInt(value: number): string {
  return intFormatter.format(value);
}

export function fmtDate(value: string | Date): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return dateFormatter.format(d);
}

export function fmtDateTime(value: string | Date): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return dateTimeFormatter.format(d);
}

export function fmtPercent(value: number, decimals = 1): string {
  return `${value.toFixed(decimals)}%`;
}
